const APP_NAME = 'GlobalSearch';
const APP_CONTAINER_ID = 'GlobalSearchApp';
const APP_CONTAINER_ID_MOBILE = 'mobileViewOverlay';

const MOBILE_BREAKPOINT_MAX = 719;
const DESKTOP_BREAKPOINT_MIN = 720;
const OLD_MOBILE_BREAKPOINT_MAX = 960;
const MOBILE_MAX_WIDTH_MEDIA_QUERY = `(max-width: ${OLD_MOBILE_BREAKPOINT_MAX}px)`;

const URL_PARTNUMBERS_DIVIDER = '|';
const BAZAAR_VOICE_PASS_KEY = 'caa2W9M6aS5cNiMUWK099g7XuTDZDd7youNA0gsroteFs';
const AVAILABILITY_TAGS_WITH_PRICES = ['ADD_TO_CART', 'PURCHASE_CD', 'NOT_AVAILABLE'];
const DISCONTINUED = 'DISCONTINUED';
const REPLACEMENT = 'REPLACEMENT';
const NOT_AVAILABLE_IN_THIS_SITE = 'NOT_AVAILABLE_IN_SITE';
const CARTABLE_STATUSES = ['ADD_TO_CART', 'PURCHASE_CD'];
const CALL_FOR_MORE_INFORMATION = ['NOT_AVAILABLE', 'DISCONTINUED', 'NOT_AVAILABLE_IN_SITE'];
const DOWNLOAD = 'DOWNLOAD';
const UNRELEASED = 'UNRELEASED';

const NOTIFICATION_TYPE_INFO = 'info';
const NOTIFICATION_TYPE_COPIED = 'copied';
const NOTIFICATION_TYPE_WARNING = 'warning';
const NOTIFICATION_TYPE_ERROR = 'error';

const MIN_SEARCH_SYMBOLS_COUNT = 3;
const POPULAR_SEARCHES_COUNT = 0;
const ENTER_KEY = 13;

const DEFAULT_GLOBAL_SEARCH_TRANSLATIONS = {
    'search.fss.label.searchBox': 'Search apc.com',
    'search.fss.label.showAllResults': 'Show all results',
    'searchBox.inProductCategories': 'In Product Categories',
    'searchBox.inProducts': 'In Products',
    'searchBox.noSuggestionsFound': 'No suggestions found',
    'searchBox.searching': 'Searching…',
    cancel: 'Cancel',
    Discontinued: 'Discontinued',
    'search.fss.recommendedReplacement': 'Recommended replacement',
};

module.exports = {
    APP_NAME,
    APP_CONTAINER_ID,
    APP_CONTAINER_ID_MOBILE,
    MOBILE_BREAKPOINT_MAX,
    DESKTOP_BREAKPOINT_MIN,
    OLD_MOBILE_BREAKPOINT_MAX,
    MOBILE_MAX_WIDTH_MEDIA_QUERY,
    URL_PARTNUMBERS_DIVIDER,
    BAZAAR_VOICE_PASS_KEY,
    AVAILABILITY_TAGS_WITH_PRICES,
    DISCONTINUED,
    REPLACEMENT,
    NOT_AVAILABLE_IN_THIS_SITE,
    CARTABLE_STATUSES,
    CALL_FOR_MORE_INFORMATION,
    DOWNLOAD,
    UNRELEASED,
    NOTIFICATION_TYPE_INFO,
    NOTIFICATION_TYPE_COPIED,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR,
    MIN_SEARCH_SYMBOLS_COUNT,
    POPULAR_SEARCHES_COUNT,
    ENTER_KEY,
    DEFAULT_GLOBAL_SEARCH_TRANSLATIONS,
};
